import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

//assets
import slug from "../../slug"

//styles
import * as Styled from "./karriere.styles"

const query = graphql`
  {
    mitarbeiterin: file(relativePath: { regex: "/mitarbeiterin.png$/" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
  }
`

const Karriere = () => {
  const data = useStaticQuery(query)
  const mitarbeiterin = getImage(data.mitarbeiterin)

  return (
    <Styled.Wrapper>
      <Styled.Überschrift>
        <div className="img__container">
          <GatsbyImage image={mitarbeiterin} alt="" />
        </div>
        <h2>Ihr Job bei SPÄTSOMMER</h2>
      </Styled.Überschrift>
      <Styled.Content>
        <div className="img__container">
          <GatsbyImage image={mitarbeiterin} alt="" />
        </div>
        <Styled.Jobs>
          <h2>Wir suchen:</h2>
          <ul>
            <li>Examinierte Pflegefachkraft (m/w/d)</li>
            <li>
              Pflegefachkraft (m/w/d) mit Weiterbildung zum/zur
              Praxisanleiter/in
            </li>
            <li>
              Pflegefachkraft (m/w/d) mit Weiterbildung zum/zur Wundmanager/in
            </li>
            <li>Pflegeassistent (m/w/d) für den ambulanten Pflegedienst</li>
            <li>
              Pflegeassistent (m/w/d) für die Wohngemeinschaft in Oberasbach
            </li>
            <li>Mitarbeiter/in für die Hauswirtschaft und Betreuung</li>
            <li>Ehrenamtliche/n Helfer/in für Betreuungsmaßnahmen</li>
            <li>
              Auszubildende zur generalistischen Ausbildung zur Pflegefachfrau/
              Pflegefachmann
            </li>
          </ul>
          <Link to={slug[4]} aria-label="Mehr Informationen">
            <span>Mehr Informationen</span>
          </Link>
          <br />
          <a
            href="mailto:hallo@spaetsommer.de"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Bewerben Sie sich jetzt"
          >
            <span>Bewerben Sie sich jetzt</span>
          </a>
        </Styled.Jobs>
      </Styled.Content>
    </Styled.Wrapper>
  )
}

export default Karriere
